import { Button, Dialog, Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { FunctionComponentElement, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useAutoFocus } from '$shared/custom-hooks/useAutoFocus';

import { useContactSupport } from '$components/chat-bot/useContactSupport';

export interface ErrorDialogRetryProps {
  onTryAgain: () => void;
  title: string;
  message: string;
}

export function ErrorDialogRetry({
  onTryAgain,
  title,
  message,
}: ErrorDialogRetryProps): FunctionComponentElement<ErrorDialogRetryProps> {
  const { t } = useTranslation();
  const handleContactSupport = useContactSupport();
  const closeButtonRef = useRef<null | HTMLButtonElement>(null);
  const tryAgainButtonRef = useRef<null | HTMLButtonElement>(null);

  useAutoFocus(closeButtonRef);
  return (
    <>
      <div className="flex flex__dir--column flex__ai--center text-align-center">
        <Icon
          name="failed"
          className="bg-red-500 m-bottom-xxl"
          size={IconSizeClasses.XLarge}
        />
        <Dialog.Title>{title}</Dialog.Title>
        <Dialog.Description className="m-bottom-xxs">{message}</Dialog.Description>
        <p className="m-top-xl">
          <span>{t('errors.contactSupport')} </span>
          <Dialog.Close>
            <button
              type="button"
              onClick={handleContactSupport}
              className="btn-as-link font-weight-regular color-blue-500"
            >
              {t('errors.contactSupport2')}
            </button>
          </Dialog.Close>
        </p>
      </div>
      <Dialog.Actions className="m-top-xxl">
        <Button ref={tryAgainButtonRef} onClick={onTryAgain} variant="secondary">
          {t('shared.tryAgain')}
        </Button>

        <Dialog.Close>
          <Button ref={closeButtonRef} className="btn--solid">
            {t('shared.close')}
          </Button>
        </Dialog.Close>
      </Dialog.Actions>
    </>
  );
}
